import { useEffect, useState } from "react";

import { Box } from "@mui/material";

import useData from "../../hooks/useData";

import DataTable from "../elements/DataTable";

const EntityList = ({
  entityList,
  entitySchema,
  onRowClick,
  subTable,
  addSubRecord,
  tableHeight,
  columns,
  allowSelect,
  onSelectAll,
  onSelect,
  selectedItems,
  onSortChange,
  orderBy,
  order,
}) => {
  useEffect(() => {
    if (!columns) return;
  }, [columns]);

  if (!columns) return null;

  return (
    <Box>
      <DataTable
        data={entityList}
        columns={columns}
        onRowClick={onRowClick}
        subTable={subTable}
        addSubRecord={addSubRecord}
        tableHeight={tableHeight}
        allowSelect={allowSelect}
        onSelectAll={onSelectAll}
        onSelect={onSelect}
        selectedItems={selectedItems}
        onSortChange={onSortChange}
        orderBy={orderBy}
        order={order}
      />
    </Box>
  );
};

export default EntityList;
